import { Component, OnInit } from '@angular/core';
import {
  EmptyStateSize,
  EmptyStateType
} from '@design-system/components/m-empty-states';
import { CommonAuthService } from '@libs/common-services';

@Component({
  selector: 'portal-setup',
  templateUrl: './in-progress.component.html',
  styleUrls: ['./in-progress.component.scss']
})
export class InProgressComponent implements OnInit {
  public EmptyStateSize = EmptyStateSize;
  public EmptyStateType = EmptyStateType;
  public name = '';

  constructor(private readonly authService: CommonAuthService) {}

  ngOnInit(): void {
    const user = this.authService.getUser();
    if (user) {
      this.name = user.getFirstName();
    }
  }

  navigateToSupportPage() {
    window.open(
      'https://support.measured.com/article/w1bzg711cy-xcd-overview',
      '_blank'
    );
  }
}
